const TOKEN_KEY = "@mychapperoneUserDashboardtoken:key";
const CONTRACT_KEY = "@contractChapperonetoken:key";
const ORG_KEY = "@organisation:key";

export { TOKEN_KEY, CONTRACT_KEY, ORG_KEY };
